import { makeAutoObservable, configure } from 'mobx';
import { ReportHubConfig } from '../types';

configure({
  isolateGlobalState: true,
});

interface FilterConfig {
  field: string;
  label: string;
  operator: string;
  component: string;
  componentProps: Record<string, any>;
}

type FilterMap = Record<string, {
  operator: string;
}>;

class GlobalStore {
  // 应用ID
  appId = '';
  // 内部员工ID
  staffname = '';
  config: ReportHubConfig = {};

  // 配置
  appConfig: Record<string, any> = {};
  filterConfig: Array<FilterConfig> = [];
  filterMap: FilterMap = {};

  constructor() {
    makeAutoObservable(this);
  }

  get optinalStarteDate() {
    return this.appConfig.visualization?.optionalStartDate;
  }

  setAppId(id: string) {
    this.appId = id;
  }

  setStaffname(staffname: string) {
    this.staffname = staffname;
  }

  setConfig(config: Partial<ReportHubConfig>) {
    this.config = {
      ...this.config,
      ...config || {},
    };
  }

  setAppConfig(config: string) {
    try {
      this.appConfig = JSON.parse(config);
    } catch (error) { }
  }

  setFilterConfig(data: Array<any>) {
    const filterMap: FilterMap = {};
    this.filterConfig = data.map((v) => {
      const { field, label, operator, component, componentProps } = v;
      filterMap[field] = { operator };
      return {
        field,
        label,
        operator,
        component,
        componentProps: JSON.parse(componentProps),
      };
    });
    this.filterMap = filterMap;
  }

  /**
   * 获取页面地址
   */
  getPathname() {
    // 获取当前页面地址，按优先级从urlHandler/location.pathname获取，默认为location.pathname
    let url;
    if (typeof this.config.urlHandler === 'function') {
      url = this.config.urlHandler();
    }
    return url || window.location.pathname || '/';
  }
}

const globalStore = new GlobalStore();

export default globalStore;
